import moment from "moment";
import { useHistory } from "react-router-dom";
import React from "react";
import NotificationCardProps from "../../services/models/notificationsModels/notificationCard.model";

function commentsTruncate(message: string) {
  let finalText = message;
  const splitMessage = message.split('information');

  if (splitMessage.length > 1) {
    let comments = splitMessage[1];

    if (comments.length > 100) {
      comments = comments.slice(0, 100) + '...';
    }

    finalText = `${splitMessage[0]}information ${comments}`;
  }

  return finalText;
}

function NotificationCard({ message, time, contentType, isNew, hideBorder, onClick, iconURL }: NotificationCardProps): JSX.Element {
  const history = useHistory()

  function decreaseCount() {
    // let latestCount = unReadCount - 1
    // if (latestCount >= 0)
    //   dispatch({ type: UPDATE_NOTIFICATION_UNREAD_COUNT, payload: latestCount })
  }

  const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    // If clicking on a link, handle it separately
    if (target.tagName === 'A' || target.closest('a')) {
      e.stopPropagation(); // Prevent button onClick from firing
      const link = target.tagName === 'A' ? target as HTMLAnchorElement : target.closest('a') as HTMLAnchorElement;
      if (link) {
        e.preventDefault();
        const hrefAttr = link.getAttribute('href');
        const fullUrl = link.href;
        
        if (!hrefAttr && !fullUrl) return;
        
        try {
          // Try to parse as URL to get pathname and check if external
          const url = new URL(fullUrl);
          const pathname = url.pathname;
          const isPDF = pathname.toLowerCase().endsWith('.pdf') || fullUrl.toLowerCase().includes('.pdf');
          const isExternal = url.origin !== window.location.origin;
          
          // Check if it's an internal route (starts with /access or is same origin)
          const isInternalRoute = pathname.startsWith('/access') || (!isExternal && !isPDF);
          
          if (isInternalRoute) {
            // Internal route - use React Router navigation
            history.push(pathname + url.search + url.hash);
          } else {
            // External link or PDF - open in new tab
            window.open(fullUrl, '_blank', 'noopener,noreferrer');
          }
        } catch {
          // If URL parsing fails, treat hrefAttr as relative path
          // Check if it looks like an internal route
          if (hrefAttr && (hrefAttr.startsWith('/access') || hrefAttr.startsWith('/'))) {
            const isPDF = hrefAttr.toLowerCase().endsWith('.pdf');
            if (!isPDF) {
              // Internal route - use React Router navigation
              history.push(hrefAttr);
            } else {
              // PDF with relative path - construct full URL and open in new tab
              window.open(fullUrl, '_blank', 'noopener,noreferrer');
            }
          } else {
            // Fallback: open in new tab
            window.open(fullUrl, '_blank', 'noopener,noreferrer');
          }
        }
      }
    }
  };

  return <button onClick={onClick ? () => {
    onClick(history)
    isNew && decreaseCount()
  } : () => {
    isNew && decreaseCount()
  }} className={`bg-white hover:bg-sideMenuHoverBg w-full p-4 flex justify-between ${!hideBorder ? 'border-b' : ''} text-left`}>
    <div className="flex items-center">
      <div className="mx-5 shrink-0 h-[36px] w-[36px] rounded-full bg-sideNavGray border border-dropDownBorder justify-center items-center flex flex-col self-center overflow-hidden">
        <img src={iconURL} className="h-full w-full object-contain" />
      </div>
      <div>
        {/* <p className="font-royalBlue">{commentsTruncate(message)}</p> */}
        <React.Suspense fallback={<p>Loading...</p>}>
          <div 
            className="font-royalBlue" 
            dangerouslySetInnerHTML={{ __html: commentsTruncate(message) }}
            onClick={handleContentClick}
          />
        </React.Suspense>
        <p className="text-textSecondaryGray text-sm font-normal">{moment(time).format('MM-DD-YYYY hh:mm a')?.replaceAll('-', '/')}</p>
      </div>
    </div>
    {isNew && <div className="h-[8px] w-[8px] bg-primary rounded-full" />}
  </button>
}

export default NotificationCard;